// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qfm8","label":"styles_label__AgsEu"};